if (process.env.WEBPACK) {
    window.requestAnimFrame = (function () {
        return (
            window.requestAnimationFrame ||
            (window as any).webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame
        );
    })();
    window.cancelAnimationFrame =
        window.cancelAnimationFrame ||
        window.mozCancelAnimationFrame ||
        function (requestID) {
            clearTimeout(requestID);
        };
}

